(function () {
  if (window.__emiCheckoutBound) return;
  window.__emiCheckoutBound = true;

  var refreshTimer = null;
  var trailingTimer = null;

  document.addEventListener(
    "click",
    function (event) {
      var control = event.target.closest(
        ".emi-checkout-template, .emi-checkout-button",
      );
      if (!control) return;

      var wrap = control.closest(
        ".emi-checkout-template-wrap, .emi-checkout-button-wrap",
      );
      if (!wrap) return;

      event.preventDefault();

      var appButton = findVelocityAppButton(wrap);
      if (appButton) {
        appButton.click();
        return;
      }

      var formId = wrap.getAttribute("data-emi-form");
      var form = formId ? document.getElementById(formId) : null;
      var submitName = wrap.getAttribute("data-emi-submit-name") || "add";
      var submitter =
        form && submitName === "checkout"
          ? findFormSubmitter(form, formId, submitName)
          : null;
      if (submitter) {
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit(submitter);
        } else {
          submitter.click();
        }
        return;
      }

      startVelocityCheckout(wrap);
    },
    true,
  );

  function startVelocityCheckout(root) {
    var location = root.getAttribute("data-emi-location") || "product";
    if (
      window.VelocityBNPL &&
      typeof window.VelocityBNPL.startCheckout === "function"
    ) {
      window.VelocityBNPL.startCheckout(location);
    }
  }

  function findVelocityAppButton(wrap) {
    var location = wrap.getAttribute("data-emi-location") || "product";
    var trigger = wrap.getAttribute("data-emi-trigger");
    var selectors = [];
    if (trigger) selectors.push(trigger);
    if (location === "cart-page") {
      selectors.push(
        "#app-test-button-cart-page",
        '[data-location-type="cart-page"]',
      );
    } else if (location === "cart-drawer") {
      selectors.push(
        "#app-test-button-drawer",
        "#app-test-button-cart-drawer",
        '[data-location-type="cart-drawer"]',
      );
    } else {
      selectors.push(
        "#app-test-button-product",
        '[data-location-type="product"]',
      );
    }
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function findFormSubmitter(form, formId, submitName) {
    if (form.elements && form.elements.namedItem) {
      var named = form.elements.namedItem(submitName);
      if (named) return named.nodeType ? named : named[0];
    }
    return (
      form.querySelector('[name="' + submitName + '"]') ||
      document.querySelector(
        '[name="' + submitName + '"][form="' + formId + '"]',
      )
    );
  }

  function invalidateVelocityCartCache() {
    var cache = window.VelocityBNPL && window.VelocityBNPL.__cartDataCache;
    if (!cache) return;
    cache.value = null;
    cache.fetchedAt = 0;
    cache.inFlightPromise = null;
  }

  function emiMonthlyCents(totalCents, months) {
    var tenure = Number(months) || 4;
    var total = Math.max(0, Number(totalCents) || 0);
    return Math.round(total / tenure / 100) * 100;
  }

  function formatEmiMoney(cents) {
    if (typeof formatMoney === "function") {
      var formatted = formatMoney(
        cents,
        (window.theme && window.theme.moneyFormat) || "",
      );
      return String(formatted).replace(/\.00(?!\d)/, "");
    }
    return "₹" + Math.round(Number(cents || 0) / 100);
  }

  function applyEmiAmount(wrap, totalCents) {
    var downpayment = Number(wrap.getAttribute("data-emi-downpayment") || 0);
    var months = wrap.getAttribute("data-emi-months") || 4;
    if (downpayment > 0) months = 3;
    var financed = Math.max(0, (Number(totalCents) || 0) - downpayment);
    var monthly = emiMonthlyCents(financed, months);
    var money = formatEmiMoney(monthly);
    var templateAmount = wrap.querySelector(".emi-checkout-template__amount");
    var classicAmount = wrap.querySelector(".emi-checkout-button__amount");
    if (templateAmount) templateAmount.textContent = money + "/month";
    if (classicAmount) classicAmount.textContent = money + " / month";

    var control = wrap.querySelector(
      ".emi-checkout-template, .emi-checkout-button",
    );
    if (control) {
      control.setAttribute(
        "aria-label",
        "Buy on EMI with Velocity, from " + money + " per month",
      );
    }
  }

  function getProductQuantity(wrap) {
    var formId = wrap.getAttribute("data-emi-form");
    var input = null;
    if (formId) {
      input =
        document.querySelector(
          'input[name="quantity"][form="' + formId + '"]',
        ) ||
        document.querySelector("#" + formId + ' input[name="quantity"]') ||
        document.querySelector("#" + formId + " .quantity__input");
    }
    if (!input) {
      input = document.querySelector(
        ".product__info-container input.quantity__input, product-form input[name='quantity'], .product-form input[name='quantity']",
      );
    }
    var qty = parseInt(input && input.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function updateProductEmiButtons() {
    document
      .querySelectorAll(
        '.emi-checkout-template-wrap[data-emi-location="product"], .emi-checkout-button-wrap[data-emi-location="product"]',
      )
      .forEach(function (wrap) {
        if (wrap.hidden) return;
        var unit = Number(wrap.getAttribute("data-emi-unit-price") || 0);
        var qty = getProductQuantity(wrap);
        applyEmiAmount(wrap, unit * qty);
      });
  }

  function updateCartEmiButtons(cart) {
    var total = Number(cart && cart.total_price) || 0;
    var empty = !cart || Number(cart.item_count) === 0;
    var wraps = document.querySelectorAll(
      '.emi-checkout-template-wrap[data-emi-location="cart-page"], .emi-checkout-template-wrap[data-emi-location="cart-drawer"], .emi-checkout-button-wrap[data-emi-location="cart-page"], .emi-checkout-button-wrap[data-emi-location="cart-drawer"]',
    );

    wraps.forEach(function (wrap) {
      wrap.hidden = empty || total <= 0;
      if (wrap.hidden) return;
      applyEmiAmount(wrap, total);
    });
  }

  function refreshFromCartJs() {
    var cartUrl =
      (window.routes && window.routes.cart_url
        ? window.routes.cart_url
        : "/cart") + ".js";
    fetch(cartUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js failed");
        return response.json();
      })
      .then(updateCartEmiButtons)
      .catch(function () {});
  }

  function isProductQuantityControl(target) {
    if (!target || !target.closest) return false;
    if (target.closest("cart-items, cart-drawer-items, .cart-item")) return false;
    return !!(
      target.closest("quantity-input") ||
      target.matches?.('input[name="quantity"], .quantity__input') ||
      target.closest(".product__info-container .quantity")
    );
  }

  function scheduleProductEmiRefresh() {
    setTimeout(updateProductEmiButtons, 0);
  }

  function scheduleEmiCheckoutRefresh() {
    updateProductEmiButtons();
    invalidateVelocityCartCache();
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      invalidateVelocityCartCache();
      refreshFromCartJs();
      updateProductEmiButtons();
    }, 80);

    if (!trailingTimer) {
      trailingTimer = setTimeout(function () {
        trailingTimer = null;
        invalidateVelocityCartCache();
        refreshFromCartJs();
        updateProductEmiButtons();
      }, 450);
    }
  }

  document.addEventListener(
    "input",
    function (event) {
      if (isProductQuantityControl(event.target)) scheduleProductEmiRefresh();
    },
    true,
  );
  document.addEventListener(
    "change",
    function (event) {
      if (isProductQuantityControl(event.target)) scheduleProductEmiRefresh();
    },
    true,
  );
  document.addEventListener(
    "click",
    function (event) {
      if (isProductQuantityControl(event.target)) scheduleProductEmiRefresh();
    },
    true,
  );

  window.refreshEmiCheckoutButtons = scheduleEmiCheckoutRefresh;

  if (typeof subscribe === "function") {
    var cartUpdateEvent =
      typeof PUB_SUB_EVENTS !== "undefined"
        ? PUB_SUB_EVENTS.cartUpdate
        : "cart-update";
    subscribe(cartUpdateEvent, scheduleEmiCheckoutRefresh);
  }

  document.addEventListener("cart:updated", scheduleEmiCheckoutRefresh);

  updateProductEmiButtons();
})();
